import React from 'react';
import NumberFormat from 'react-number-format';


export default function ZipcodeField(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      allowLeadingZeros
      isNumericString
      minLength={5}
      maxLength={5}
    />
  );
}
